import {
  ENQUEUE_SNACKBAR,
  REMOVE_SNACKBAR,
  ENQUEUE_BANNER,
  REMOVE_BANNER,
  ACTIVATE_BANNER,
  SET_FREE_CREDIT_AWARE,
  CLEAR_BANNER_STATE,
} from '../actions';

export const initialState = {
  notifications: [],
  bannerNotifications: [],
  activeMessage: null,
  freeCreditAware: false, // Set this to false to enable trial credit banners. Also don't forget
  // to change unit tests for the reducer
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ENQUEUE_SNACKBAR:
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            ...action.notification,
          },
        ],
      };

    case REMOVE_SNACKBAR:
      return {
        ...state,
        notifications: state.notifications.filter(
          (notification) => notification.key !== action.key,
        ),
      };

    case ENQUEUE_BANNER:
      return {
        ...state,
        bannerNotifications: [
          ...state.bannerNotifications,
          {
            ...action.notification,
          },
        ],
      };

    case ACTIVATE_BANNER:
      return {
        ...state,
        activeMessage: state.bannerNotifications.shift(),
        bannerNotifications: state.bannerNotifications,
      };

    case REMOVE_BANNER:
      return {
        ...state,
        activeMessage: null,
      };

    case SET_FREE_CREDIT_AWARE:
      return {
        ...state,
        freeCreditAware: true,
      };

    case CLEAR_BANNER_STATE:
      // Only clear banner state.
      // SnackBar state is not changed.
      return {
        ...state,
        bannerNotifications: [],
        activeMessage: null,
        freeCreditAware: false,
      };

    default:
      return state;
  }
};
